import { StakeController } from './features/stake';
import { WalletController } from './features/wallet';
import {WithdrawController,WithdrawService} from './features/withdraw'
import { ProtonService } from './services/Proton';
export class SnipCore{

    constructor(){

        window["Snipcore"] = this;
        this['proton'] = new ProtonService()
        this['Withdraw'] = WithdrawController
        this['Wallet'] = WalletController
        this['Stake'] = StakeController

    }

}
const main = new SnipCore();
    
